/**
 * Curated SEO copy for storefront landing pages, keyed by URL slug.
 *
 * Shared by /products/<slug> and /buy/<slug>. It used to live inside
 * ProductListPage, which serves only /products/<slug> — but the high-intent
 * slugs (airtime-usd, zetdc-usd, econet-usd-airtime) resolve to open-amount
 * categories that REDIRECT to /buy/<slug>, a page that never read this map. The
 * curated copy for the most valuable pages on the site was therefore dead code
 * that never rendered.
 *
 * Any slug without an entry falls back to generated copy, so a new category
 * still gets sensible meta with no code change.
 */
export const LANDING_COPY = {
  airtime: {
    title: "Buy Airtime to Zimbabwe — Instant Top-Up from South Africa",
    intro:
      "Send instant airtime to any Zimbabwean network — Econet, NetOne and Telecel — from South Africa or anywhere in the diaspora. Pay securely and your recipient gets credited in seconds.",
  },
  econet: {
    title: "Buy Econet Airtime & Data Bundles — Instant Delivery",
    intro:
      "Top up Econet airtime and buy Econet data bundles online with instant delivery to Zimbabwe. Pay by voucher, card or instant EFT from South Africa and the diaspora.",
  },
  netone: {
    title: "Buy NetOne Airtime & Data Bundles — Instant Delivery",
    intro:
      "Recharge NetOne airtime and OneFusion data bundles online with instant delivery to Zimbabwe. Fast, secure top-ups from South Africa and the diaspora.",
  },
  telone: {
    title: "Buy TelOne Bundles & Broadband — Pay Online",
    intro:
      "Pay for TelOne broadband and bundles online with instant confirmation. Convenient for Zimbabweans paying from South Africa and abroad.",
  },
  taura: {
    title: "Buy Taura Bundles — Instant Delivery to Zimbabwe",
    intro: "Buy Taura bundles online with instant delivery. Quick and secure from South Africa and the diaspora.",
  },
  zesa: {
    title: "Buy ZESA Tokens Online — Instant Electricity Tokens for Zimbabwe",
    intro:
      "Buy ZESA prepaid electricity tokens online and have the token delivered instantly. Pay for power back home from South Africa or anywhere in the diaspora.",
  },
  "bill-payments": {
    title: "Pay Zimbabwe Bills Online — Fast & Secure",
    intro:
      "Pay Zimbabwean bills online from South Africa and the diaspora with instant confirmation and secure payment options.",
  },
  // ── Live category slugs (must match slugifyCategory(<category name>) of a real
  // category — see /popular_categories). These are the pages actually linked from
  // the sitemap and prerendered at build time. Keys above are kept as legacy
  // fallbacks for old URLs.
  "econet-airtime": {
    title: "Buy Econet Airtime Online — Instant Top-Up to Zimbabwe",
    intro:
      "Top up Econet airtime online with instant delivery to any Econet number in Zimbabwe. Pay by voucher, card or instant EFT from South Africa and the diaspora.",
  },
  "econet-data": {
    title: "Buy Econet Data Bundles — Instant Delivery to Zimbabwe",
    intro:
      "Buy Econet data bundles online and have them delivered instantly to any Econet number in Zimbabwe. Secure payments from South Africa and the diaspora.",
  },
  "econet-usd-airtime": {
    title: "Buy Econet USD Airtime — Instant Top-Up to Zimbabwe",
    intro:
      "Recharge Econet USD airtime online with instant delivery. Pay securely by voucher, card or instant EFT from South Africa and the diaspora.",
  },
  "telecel-airtime": {
    title: "Buy Telecel Airtime Online — Instant Top-Up to Zimbabwe",
    intro:
      "Top up Telecel airtime online with instant delivery to any Telecel number in Zimbabwe. Fast, secure payments from South Africa and the diaspora.",
  },
  "netone-usd-airtime": {
    title: "Buy NetOne USD Airtime — Instant Top-Up to Zimbabwe",
    intro:
      "Recharge NetOne USD airtime online with instant delivery to Zimbabwe. Pay by voucher, card or instant EFT from South Africa and the diaspora.",
  },
  zetdc: {
    title: "Buy ZESA Tokens Online — Instant ZETDC Electricity Tokens",
    intro:
      "Buy ZESA (ZETDC) prepaid electricity tokens online and get the token instantly. Pay for power back home from South Africa or anywhere in the diaspora.",
  },
  "zetdc-usd": {
    title: "Buy ZESA Tokens in USD — Instant ZETDC Electricity Tokens",
    intro:
      "Buy ZETDC prepaid electricity tokens in USD with instant token delivery. Convenient and secure for Zimbabweans paying from abroad.",
  },
  nyaradzo: {
    title: "Pay Nyaradzo Policy Online — Fast & Secure from the Diaspora",
    intro:
      "Pay your Nyaradzo funeral policy online from South Africa and the diaspora with instant confirmation and secure payment options.",
  },
  "nyaradzo-usd": {
    title: "Pay Nyaradzo Policy in USD — Fast & Secure from the Diaspora",
    intro:
      "Pay your Nyaradzo policy in USD online with instant confirmation. Simple, secure payments from South Africa and abroad.",
  },
  "airtime-usd": {
    title: "Buy USD Airtime for Zimbabwe — All Networks, Instant Delivery",
    intro:
      "Buy USD airtime for Econet, NetOne and Telecel online with instant delivery to Zimbabwe. Secure payments from South Africa and the diaspora.",
  },
}
